
import { Select, Option, Input } from "element-ui"
import { FILTER_KEY } from "@/constants/storeLocator"

export default {
  name: "StoreLocatorFilter",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input
  },
  props: {
    servicesOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      filter: {
        search: "",
        district: "",
        area: "",
        services: ""
      },
      districtOptions: [
        {
          label: "Central",
          value: "Central"
        },
        {
          label: "South",
          value: "South"
        },
        {
          label: "North",
          value: "North"
        },
        {
          label: "East",
          value: "East"
        },
        {
          label: "West",
          value: "West"
        }
      ],
      allOptions: [],
      FILTER_KEY
    }
  },
  computed: {
    areaOptions() {
      return this.allOptions
        .filter(item => {
          if (this.filter.district.length === 0) return true
          return this.filter.district == item.municipal
        })
        .map(item => ({
          label: item.districtName,
          value: item.district
        }))
    }
  },
  watch: {
    filter: {
      handler(val) {
        this.$emit("change", val)
      },
      deep: true
    }
  },
  methods: {
    handleChanged(key, value) {
      if (key === FILTER_KEY.DISTRICT) {
        this.filter.area = ""
      }
      this.filter[key] = value
    }
  }
}
